import { Component, OnInit, Input } from '@angular/core';
import { CalculatorModel } from 'src/app/models/calculator';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { CorporateSavingsService } from 'src/app/services/corporate-savings.service';
import * as moment from 'moment';
import { CalculatorData } from 'src/app/models/calculatorData';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-calculator',
  templateUrl: './calculator.component.html',
  styleUrls: ['./calculator.component.scss']
})
export class CalculatorComponent implements OnInit {

  @Input('calculator') calculator: CalculatorModel;
  formErrors: any;
  frequencyOptions$ = new BehaviorSubject([]);
  durationOptions$ = new BehaviorSubject([]);
  targetTypes$ = new BehaviorSubject([]);
  loadingFrequency$ = new BehaviorSubject(false);
  loadingDuration$ = new BehaviorSubject(false);
  loadingTargetTypes$ = new BehaviorSubject(false);
  isVisible = false;
  calculating$ = new BehaviorSubject(false);
  previewDetails$: BehaviorSubject<CalculatorData>;
  errorStatus$ = new BehaviorSubject('');
  errorMessage$ = new BehaviorSubject('');
  error$ = new BehaviorSubject(false);
  formErrors$ = new BehaviorSubject([]);

  constructor(private router: Router, private corporateSavingsService: CorporateSavingsService, public utilityService: UtilityService) {
    this.previewDetails$ = new BehaviorSubject(new CalculatorData());
  }

  ngOnInit() {
    this.loadingFrequency$.next(true);
    this.loadingTargetTypes$.next(true);

    this.corporateSavingsService.GetFrequency().subscribe(
      res => this.frequencyOptions$.next(res.result),
      error => this.handleError(error),
      () => this.loadingFrequency$.next(false));

    this.corporateSavingsService.GetTargetTypes().subscribe(
      res => this.targetTypes$.next(res.result),
      error => this.handleError(error),
      () => this.loadingTargetTypes$.next(false));
  }

  handleError(error) {
    this.errorStatus$.next(`${error.status}`);
    this.errorMessage$.next(error.statusText);
    this.error$.next(true);
  }

  generateDurationOptions = (limit) => {
    const arr = [];
    for (let index = 1; index <= limit; index++) {
      arr[index] = index;
    }

    this.durationOptions$.next(arr);
  }

  formatDurationLabel = (duration) => {
    if (duration) {
      return duration === 1 ? `${duration} year` : `${duration} years`;
    }
  }

  disabledDate = (current: Date): boolean => {
    // Cannot select days less than 18 yrs
    // cannot select days greater than 64yrs
    var years = moment().diff(current, 'years', false);
    return years < 18 || years > 64;
  };

  onChangeDate = () => {
    this.loadingDuration$.next(true);
    const year = new Date(this.calculator.dob).getFullYear();
    this.corporateSavingsService.GetTermFromAge(year).subscribe(
      res => {
        if (res.result === 0) {
          // handle error for invalid age
          let errorArray = [];
          errorArray.push(`Please enter ages between 18 years and 64 years `);
          this.formErrors$.next(errorArray);
          return;
        }
        return this.generateDurationOptions(res.result);
      }, error => this.handleError(error),
      () => this.loadingDuration$.next(false));
  }

  isInputValid(name) {
    if (this.formErrors$.value.length) {
      return this.formErrors$.value[0].toLowerCase().includes(name);
    }
    return false;
  };

  validateEntry() {
    var amount = this.utilityService.formatAmountToNumber(this.calculator.amount);
    return (
      amount > 0 && this.calculator.dob && this.calculator.duration && this.calculator.frequency && this.calculator.product && this.calculator.savingsPlan);
  }

  validateAmount() {
    let maxamount = 60000;
    let errorArray = [];

    if (this.calculator.frequency.toLowerCase() === 'monthly' && this.calculator.amount < (maxamount / 12)) {
      errorArray.push(`Please enter valid amount at least ${maxamount / 12} monthly`);
    }

    if (this.calculator.frequency.toLowerCase() === 'quarterly' && this.calculator.amount < (maxamount / 4)) {
      errorArray.push(`Please enter valid amount at least ${maxamount / 4} quarterly`);
    }

    if (this.calculator.frequency.toLowerCase() === 'semi-annually' && this.calculator.amount < (maxamount / 2)) {
      errorArray.push(`Please enter valid amount at least ${maxamount / 2} semi-annually`);
    }

    if (this.calculator.frequency.toLowerCase() === 'annually' && this.calculator.amount < maxamount) {
      errorArray.push(`Please enter valid amount at least ${maxamount} annually`);
    };


    this.formErrors$.next(errorArray);
    return !errorArray.length;
  }

  showModal(): void {
    this.isVisible = true;
  }

  handleOk(): void {
    this.isVisible = false;
    this.router.navigate([`/corporate-savings`]);
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  gotosavings() {
    if (this.validateAmount()) {
      var amount = this.utilityService.formatAmountToNumber(this.calculator.amount);
      this.calculating$.next(true);

      const calculatorData = {
        dob: this.utilityService.formateDate(this.calculator.dob),
        paymentFrequency: this.calculator.frequency,
        premiumOrSumAssured: amount,
        targetType: this.calculator.savingsPlan,
        term: this.calculator.duration
      };

      this.corporateSavingsService.CalculateNcspPremium(calculatorData).subscribe(
        res => {
          this.previewDetails$.next(res.result);
          this.showModal();
          return localStorage.setItem('corporate-savings', JSON.stringify(res.result));
        }, error => this.handleError(error),
        () => this.calculating$.next(false));
    }

  }

  formatValue(val) {
    this.calculator.amount = this.utilityService.formatAmountToString(val) as any;
  }

  closeModal() {
    this.error$.next(false);
  }

}
